import { ChangeDetectionStrategy, Component, afterRenderEffect, viewChild } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { CartContentViewComponent } from '@shared/modules/cart/components/cart-content-view/cart-content-view.component';
import { CartState } from '@shared/modules/cart/state/cart.state';
import {
  DynamicOverlayDirective,
  DynamicOverlayDirective as DynamicOverlayDirective_1
} from '@shared/modules/dynamic-overlay/dynamic-overlay.directive';

@Component({
  selector: 'app-cart-header-button',
  templateUrl: './cart-header-button.component.html',
  styleUrl: './cart-header-button.component.scss',
  imports: [MatIconButton, DynamicOverlayDirective_1, MatBadge, MatIcon, CartContentViewComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartHeaderButtonComponent {
  readonly overlayRef = viewChild('overlayRef', { read: DynamicOverlayDirective });
  readonly itemsCount = select(CartState.itemsCount);
  private readonly badge = viewChild(MatBadge);

  constructor() {
    // The count bubble is created by Material's matBadge directive, so the template cannot carry the attribute:
    // stamp the test id after each render, when the directive has created or updated its element (cart.md R-C2, #52).
    afterRenderEffect(() => {
      this.itemsCount();
      this.badge()?.getBadgeElement()?.setAttribute('data-testid', 'cart-button-badge');
    });
  }

  onClose() {
    this.overlayRef()?.hide();
  }
}
